'use client';

import { SvgChevronright, SvgFourLeafClover } from '@common/icon';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { useBenefitGate } from '../../_hooks/useBenefitGate';
import { useLuckyTicketCount } from '../../lucky-ticket/_hooks/useLuckyTicketCount';

const LuckyTicketCount = () => {
  const { data } = useLuckyTicketCount();

  return <>{data}</>;
};

//* 보유 행운권 수량만 useLuckyTicketCount() suspense 경계 안에서 로드하고 나머지는 즉시 렌더한다.
export const AttendanceLuckyTicketRow = () => {
  const { triggerGate, gateModals } = useBenefitGate();
  const router = useCustomRouter();

  const handleClick = () => {
    triggerGate(['login', 'adult'], () =>
      router.push(ROUTES.BENEFIT_LUCKY_TICKET.pathname),
    );
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className="group flex w-full items-center gap-16 bg-Gray-white px-20 py-16 text-left transition-colors focus-visible:bg-Gray-50 active:bg-Gray-50 xl:rounded-medium xl:border xl:border-Gray-100 xl:px-16 xl:hover:border-Gray-300 xl:hover:bg-Gray-50 xl:focus-visible:border-Gray-300"
      >
        <SvgFourLeafClover className="size-24" originalFill />
        <span className="flex-1 font-700 text-Gray-900 typo-body3">
          행운권{' '}
          <ErrorBoundary fallback={<>-</>}>
            <Suspense fallback="-">
              <LuckyTicketCount />
            </Suspense>
          </ErrorBoundary>
          장
        </span>
        <SvgChevronright className="size-16 text-Gray-400 transition group-focus-visible:translate-x-1 group-focus-visible:text-Gray-600 xl:group-hover:translate-x-1 xl:group-hover:text-Gray-600" />
      </button>
      {gateModals}
    </>
  );
};
